import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { FaLock } from "react-icons/fa";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { Constants } from "../../libs/Constants";
import AccountSummaryCard from "./AccountSummaryCard";

const getWarningMessage = (user) => {
  if (user.zoneinfo && user.zoneinfo === "self") {
    if (
      user?.dwolla_customer_status !== Constants.DWOLLA_CUSTOMER_STATUS.VERIFIED
    ) {
      return "Waiting on customer verification";
    } else if (
      user?.dwolla_verification_status !==
      Constants.DWOLLA_CUSTOMER_STATUS.VERIFIED
    ) {
      return "Waiting on bank verification";
    }
  }

  return null;
};
const AccountSummary = ({ summary, employee }) => {
  const [showHistory, setShowHistory] = React.useState(true);

  if (!employee) {
    return <></>;
  }
  return (
    <div className="mt-4">
      <Row className="m-0">
        <Col sm={12} className="p-0">
          <h5>
            Account Summary{" "}
            {summary && summary.length > 0 && (
              <Button
                size="sm"
                variant="light"
                className="text-secondary fw-bold float-right"
                onClick={() => setShowHistory(!showHistory)}
              >
                {showHistory ? (
                  <>
                    Hide <MdKeyboardArrowUp />
                  </>
                ) : (
                  <>
                    Show <MdKeyboardArrowDown />
                  </>
                )}
              </Button>
            )}
          </h5>
        </Col>
      </Row>
      <Row className="m-0">
        <Col sm={12} className="p-0">
          {getWarningMessage(employee) && (
            <div className="avere-part d-flex flex-column font-secondary text-gray p-4 align-items-center">
              <div className="p-2">
                <FaLock
                  className="pull-center"
                  style={{
                    marginLeft: "5px",
                  }}
                />
              </div>

              <div className="p-2">{getWarningMessage(employee)}</div>
            </div>
          )}
          {showHistory && summary && summary.length > 0 && (
            <div className="d-flex flex-row flex-wrap justify-content-start w-100">
              {summary?.map((summary, index) => {
                return (
                  <div className="ms-sm-4 ms-0" key={index}>
                    <AccountSummaryCard key={index} summary={summary} />
                  </div>
                );
              })}
            </div>
          )}
          {!getWarningMessage(employee) &&
            showHistory &&
            summary &&
            summary.length === 0 && (
              <div className="avere-part d-flex flex-column font-secondary text-gray p-4">
                <div className="p-2">No account summary</div>
              </div>
            )}
        </Col>
      </Row>
    </div>
  );
};

export default AccountSummary;
